angular.module("Main").controller("NoAccessController", ["$stateParams", "BookingService", "SessionService",
    function ($stateParams, BookingService, SessionService) {
        var vm = this;

        vm.loginResponseNull = $stateParams.loginResponseNull;
        vm.loginError = $stateParams.loginError;
        vm.clubId = $stateParams.cid;

        if (!SessionService.getSessionId()) {
            BookingService.loadClublink().then(function (config) {
                vm.clubUrl = config.link;
            })
        } else {
            BookingService.loadClublink().then(function (config) {
                vm.clubUrl = config.link;
            })
        }
    }]);